import { createContext, useContext } from "react";

export const LocationContext = createContext({
    isLoaded: false
})

export const useLocationContext = () => useContext(LocationContext)